import { render, staticRenderFns } from "./Alphalist.vue?vue&type=template&id=17a63b4c"
import script from "./Alphalist.vue?vue&type=script&lang=js"
export * from "./Alphalist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports